import { Bleed, Skeleton, tokens } from '@cast/design-system';
import { useCluster } from '@cast/shared-cluster-context-data-access';
import { FailedToLoad } from '@cast/shared-messages-ui';

import { useGetKentrollerStatusDetails } from 'hooks/queries/kent/useGetKentrollerStatusDetails';
import { notReachable } from 'utils/types/not-reachable';

import { KentrollerStatusRow } from './KentrollerStatusRow';

export const KentrollerStatusSection = () => {
  const { cluster } = useCluster();
  const query = useGetKentrollerStatusDetails({
    params: { clusterId: cluster.id },
  });
  return (
    <Bleed
      data-testid="kent-kentroller-status-section"
      mb
      mt={12}
      px={16}
      pt={12}
      pb={16}
      sx={{ backgroundColor: tokens.theme.bg.structural.surfaceRaised }}
    >
      {(() => {
        switch (query.status) {
          case 'pending':
            return (
              <Skeleton
                data-testid="kent-kentroller-status-section-loading"
                height={48}
                width="100%"
              />
            );
          case 'error':
            return (
              <FailedToLoad
                compact
                title="Failed to load kentroller status details"
                refresh={query.refetch}
              />
            );
          case 'success':
            return <KentrollerStatusRow statusDetails={query.data} />;
          default:
            return notReachable(query);
        }
      })()}
    </Bleed>
  );
};
